import React, { useCallback } from 'react';
import { withTranslation } from '../ChildrenContext.js';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';
import Loading from '../Loading';

const DataComponentTile = ({
    data,
    headerNames,
    headerNamesArray,
    columnData,
    loading,
    className,
    t
}) => {
    const staticNames = (t && t.dataTable) || {};

    const getKey = useCallback((data) => {
        if (React.isValidElement(data)) {
            return getKey(data.props.children);
        }
        return data;
    }, []);

    const getLabel = useCallback((key, id) => {
        if (headerNamesArray) {
            return (
                <span className={'item-title'}>
                    {headerNames[id]}
                </span>
            )
        } else {
            if ('actions' === key) {
                return null;
            }
            if (!Array.isArray(headerNames)) {
                return null;
            }
            return headerNames.map((item, i) => {
                if (item && item.keyTitle === key) {
                    return (
                        <span className={'item-title'} key={i}>
                            {item.title}
                        </span>
                    )
                }
                return null;
            })
        }
    }, [headerNamesArray, headerNames]);

    return (
        <div className="loading-wrapper">
            {loading && data?.length
                ? <div className="loading-wrapper__item"><Loading /></div>
                : null
            }
            <div className="table-responsive">
                <div className={`tiles tile-data ${className}`}>
                    {(data || []).map((item, i) => {
                        let className = item.className;
                        delete item.className;
                        return (
                            <div key={getKey(item.id || i)} className={className}>
                                {(Object.keys(item || {})).map((key, j) => {
                                    const dataCell = columnData?.body?.[j] || {};
                                    let value;

                                    if (typeof item[key] === 'object') {
                                        value = item[key];
                                    } else if (typeof item[key] === 'string'){
                                        value = Parser(item[key]);
                                    }

                                    if(value === undefined) {
                                        return null;
                                    }

                                    return (
                                        <div className={key} key={j} {...dataCell}>
                                            {getLabel(key,j)}
                                            {value}
                                        </div>
                                    )
                                })}
                            </div>
                        )
                    })}
                </div>
                {!data?.length
                    ? loading
                        ? <Loading center={true} />
                        : <div className="text-center table-notfound-sign">{staticNames.noData}</div>
                    : null
                }
            </div>
        </div>
    );
};

DataComponentTile.propTypes = {
    data: PropTypes.array,
    headerNames: PropTypes.array,
    headerNamesArray: PropTypes.bool,
    columnData: PropTypes.shape({
        header: PropTypes.object,
        body: PropTypes.object
    }),
    loading: PropTypes.bool,
    className: PropTypes.string,
    t: PropTypes.object
};

DataComponentTile.defaultProps = {
    data: [],
    headerNames: [],
    headerNamesArray: false,
    columnData: {
        header: {},
        body: {}
    },
    loading: false,
    className: '',
    t: {}
};

export default withTranslation(DataComponentTile);
